import { chempConstants } from '../../constants'

const initialState = {
  certboxList: {},
  certboxOrgList: {},
  certboxReadingList: {},
  isLoading: false,
  isFailure: false,
  showPwdPopup: false,
  receiverList: [],
  crtfInfo: {},
  readingInfo: {},
  isToken: false,
  tokenInfo: {},
}

export default function certbox(state = initialState, action) {
  switch (action.type) {
      /***********
       수신함 검색조건 변경
       ************/
    case chempConstants.SELECT_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload,
      }

      /*********
       수신함 목록 조회
       **********/
    case chempConstants.CERTBOX_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case chempConstants.CERTBOX_SUCCESS:
      return {
        ...state,
        certboxList: action.response.data?.payload,
      }
    case chempConstants.CERTBOX_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

      /***********
       증명서 수신함 히스토리 관리
       ************/
    case chempConstants.CERTBOX_HISTORY:
      return {
        ...state,
        history: action.payload,
      }

      /*********
       증명서 첨부파일 다운로드
       **********/
    case chempConstants.FILE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case chempConstants.FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFile: true,
      }
    case chempConstants.FILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFile: false,
      }
    default:
      return state
  }
}
